// Styles are following iwoca/orion Input design as close as possible
// That means we can mix Input and Checkout/Stripe components without too many visual discrepancies
// We're working with a base height of 50px for each field.

// Checkout requires more custom styling to be passed through
// Stripe adds classes explicitly

export const stripeElementStyles = {
    base: {
        fontFamily: 'Aesop, sans-serif',
        fontSize: '16px',
        fontWeight: '300',
        color: '#000',
        '::placeholder': {
            color: '#999999',
            fontFamily: 'Aesop, sans-serif',
            fontSize: '16px'
        }
    },
    invalid: {
        color: 'rgb(175 13 4)'
    }
};

export const checkoutElementStyles = {
    base: {
        fontFamily: 'Aesop, sans-serif',
        height: '50px',
        fontSize: '16px',
        border: '1px solid #cccccc',
        borderRadius: '8px',
        padding: '13px'
    },
    // focus styling is handled via .frame--focus CSS class
    focus: {},
    invalid: {
        color: 'rgb(175 13 4)'
    },
    placeholder: {
        base: {
            color: '#999999',
            fontFamily: 'Aesop, sans-serif',
            fontSize: '16px'
        }
    }
};
